import { __awaiter } from "tslib";
import { messagingServiceProvider } from './factories/messaging';
import { getSettings } from './factories/settings';
import { initOfflineMode } from './offline/offline-init';
import { PUBLIC_CONFIG, UICore } from '@mcf/ui-core';
// Fixes issue invalidating session token:
// https://michelinbvfm.atlassian.net/wiki/x/DoD4d
PUBLIC_CONFIG.BFF_AUTH.INVALIDATION_METHOD = 'appsync';
if (process.env.NODE_ENV === 'development') {
    // Following configures UI Core messaging service to send messages on INT2 env AppShell UI instance
    // in order to allow injecting locally running AS into INT2 AppShell (see ORANGE-1984).
    // If you want to embed your AS into locally running AppShell update the address in variable or comment
    // out the next line as by default UI Core is configured for local version of AppShell.
    // (this setting is not required in production because there is lambda@edge auth and document.referrer)
    PUBLIC_CONFIG.DEV_ENV_CONTAINER_MESSAGE_ORIGIN = 'https://int2-myaccount.connectedfleet.michelin.com';
    // This is for working locally with AppShell
    // PUBLIC_CONFIG.DEV_ENV_CONTAINER_MESSAGE_ORIGIN = 'https://localhost-myaccount.connectedfleet.michelin.com:1024';
}
export function mainStart() {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        setupOfflineMode();
        try {
            yield UICore.initForAWS(getSettings(), messagingServiceProvider);
            return import(/* webpackChunkName: "bootloader" */ './bootloader').then(runApp);
        }
        catch (err) {
            (_a = messagingServiceProvider.optional) === null || _a === void 0 ? void 0 : _a.sendAuthenticationError();
        }
    });
}
export default mainStart();
export function runApp(bootloaderResource) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        yield bootloaderResource.default();
        (_a = messagingServiceProvider.optional) === null || _a === void 0 ? void 0 : _a.sendLoadingReady();
    });
}
/**
 * run application via `npm run serve:offline` to enable offline mode
 * @link https://michelinbvfm.atlassian.net/wiki/spaces/Connect/pages/486834263/Offline+mode
 */
export function setupOfflineMode() {
    // following condition `process.env.MODE === 'offline'` must not be exported
    // to some function in order for Webpack to remove DataSourceProvider
    // from production build
    if (process.env.TESTMODE === 'offline') {
        initOfflineMode();
    }
}
